import React from 'react';

import Loading from "../../../Global/Loading";
import ClassProgressRow from "./ClassProgressRow";
import { states } from '../../values/enums';
import ClassProgressTableHeaders from './ClassProgressTableHeaders';

export default function ClassProgressContent(props) {
  const {
    status,
    reportData,
    isBenchmarkOnly,
    scaleId,
    isThreadOverview
  } = props;

  if (status === states.ERROR) {
    return (
      <div className="filler-text">
        Error: unable to retrieve class progress report.
      </div>
    );
  }
  
  if (!status || status === states.PENDING) {
    return (
      <div className="loaderStyle">
        <Loading />
      </div>
    );
  }

  const reportDataRows = reportData.map((studentData, index) => (
    <ClassProgressRow
      key={`class-progress-${studentData.studentId}`}
      rowNum={index}
      studentData={studentData}
      isBenchmarkOnly={isBenchmarkOnly}
      isThreadOverview={isThreadOverview}
    />
  ));

  return (
    <div className="classProgressReportContent">
      <div className="classProgressTableHeaders">
        <div className="classProgressTableSpacer"/>
        <ClassProgressTableHeaders
          scaleId={scaleId}
          isThreadOverview={isThreadOverview}
          isBenchmarkOnly={isBenchmarkOnly}
        />
      </div>
      <div className="classProgressTableRows">
        {reportDataRows}
      </div>
    </div>
  );
}
